module.exports = __webpack_public_path__ + "static/media/whichThinnerChoiceWarfarin.6e5365ca.mp3";